// extracted by mini-css-extract-plugin
export default {"container":"Payroll_container__8reWp","body":"Payroll_body__ndlnj"};